<template>
  <div class="container flex flex-column items-center">
    <div class="container__item flex flex-row items-center justify-center">
      <el-carousel :interval="4000" type="card" height="508px" style="width:100%;">
        <el-carousel-item v-for="(item,index) in imageList" :key="index">
          <el-image :src="item"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { imageHonor } from "@/axios/front";
export default {
  data() {
    return {
      imageList: []
    };
  },
  methods: {
    handleImageList() {
      imageHonor(`1`).then(res => {
        this.imageList = res.data;
      });
    }
  },
  mounted() {
    this.handleImageList();
  }
};
</script>

<style scoped lang="scss">
.container {
  &__item {
    width: 1400px;
    height: 680px;
  }
}
</style>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>


// WEBPACK FOOTER //
// src/front/company/Honor.vue